// VKGradeTables.js — Home page: loads all grades/subjects from API
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import VKLayout from "../components/VKLayout";
import VKTemplate from "../components/VKTemplate";
import { API_HEADERS } from "./config";

// ── Competitive Examinations — big-icon shortcut row on the home page ───────
const COMPETITIVE_EXAMS = [
  { icon: "🏛️", title: "TNPSC 554", subtitle: "Tamil Nadu Public Service Commission", to: "/tnpsc", color: "#2563eb" },
  { icon: "🧪", title: "NEET Physics", subtitle: "Class 11 & 12 · 29 chapters", to: "/neet-physics", color: "#16a34a" },
];

function CompetitiveExamsBanner() {
  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: "20px 16px 8px" }}>
      <div
        style={{
          background: "#fff",
          borderRadius: 18,
          padding: "22px 20px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
          border: "1px solid #e2e8f0",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: "#1e293b" }}>🎯 Competitive Examinations</div>
          <Link to="/competitive-examinations" style={{ fontSize: 12.5, fontWeight: 700, color: "#2563eb", textDecoration: "none" }}>
            View all →
          </Link>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16 }}>
          {COMPETITIVE_EXAMS.map((exam) => (
            <Link
              key={exam.title}
              to={exam.to}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                textDecoration: "none",
                background: "#f8fafc",
                border: `1px solid ${exam.color}33`,
                borderRadius: 14,
                padding: "14px 16px",
              }}
            >
              <div
                style={{
                  fontSize: 34,
                  width: 64,
                  height: 64,
                  lineHeight: "64px",
                  textAlign: "center",
                  flex: "none",
                  borderRadius: "50%",
                  background: `${exam.color}1a`,
                  border: `2px solid ${exam.color}`,
                }}
              >
                {exam.icon}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>{exam.title}</div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{exam.subtitle}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

function VKGradeTables() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const api_link = "https://api.virtualkalvi.com/vkCollectionsNew";

  useEffect(() => {
    fetch(api_link, {
      method: "GET",
      headers: API_HEADERS,
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log("API result:", result);

        if (!result.grades) {
          setLoading(false);
          return;
        }

        const flat = [];

        result.grades.forEach((g) => {
          g.subjects.forEach((s) => {
            flat.push({
              grade_text: g.grade_name,
              grade_picture: g.grade_picture,
              subject_name: s.subject_name,

              subtitle: s.collection_descriptions,
              updated_ago: s.updated_ago,

              teacher_picture: s.teacher_picture,
              teacher_name: s.teacher_name,

              link: s.collection_link,
              api_link: s.api_link,   // ⭐ ADDED — now API passes correctly

            });
          });
        });

        setData(flat);
        setLoading(false);
      })
      .catch((err) => {
       // console.error("API Error:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <VKLayout>
        <div className="text-center py-5">
          <div className="spinner-border text-primary"></div>
        </div>
      </VKLayout>
    );
  }

  return (
    <VKLayout>
      <CompetitiveExamsBanner />
      <VKTemplate
        api={api_link}
        //mapItem={() => data}
         rows={data}
      />
    </VKLayout>
  );
}

export default VKGradeTables;
